import { styled } from "@mui/material";
import { Box } from "@mui/material";

export const LoaderRoot = styled(Box)(({ theme }) => ({
  position: "absolute",
  zIndex: 15,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  backgroundImage: "linear-gradient(to bottom right, #000 0%, #143542 50%, #F8F1EB 100%)",
  backgroundSize: "200% 200%",
  animation: "gradient-animation-keyframes 25s infinite",
  pointerEvents: "none",
  transition: "all ease-in-out 0.5s",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  "@keyframes gradient-animation-keyframes": {
    "& 0%": {
      backgroundPosition: "0% 0%",
    },
    "& 50%": {
      backgroundPosition: "100% 100%",
    },
    "& 100%": {
      backgroundPosition: "0% 0%",
    },
  },
  "& .loader__logo": {
    position: "absolute",
    top: "5rem",
    left: "5rem",
    width: "8rem",
    [theme.breakpoints.down("xl")]: {
      width: "6rem",
      top: "3rem",
      left: "3rem",
    },
    [theme.breakpoints.down("lg")]: {
      width: "4rem",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
}));
